module.exports = __webpack_public_path__ + "static/media/bgTopGroup.fe746035.svg";